import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const MileageIssueRequest = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [date, setDate] = useState(new Date().toISOString());
  const [showRequest, setShowRequest] = useState(false);
  const [searchRequest, setSearchRequest] = useState("");
  const [showContract, setShowContract] = useState(false);
  const [searchContract, setSearchContract] = useState("");
  const [showRoute, setShowRoute] = useState(false);
  const [searchRoute, setSearchRoute] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [requestNo, setRequestNo] = useState("");
  const [firstRequestNo, setFirstRequestNo] = useState("");
  const [latestRequestNo, setLatestRequestNo] = useState("");
  const [newRequestNo, setNewRequestNo] = useState("");
  const [contractsList, setContractsList] = useState([]);
  const [contractNo, setContractNo] = useState("");
  const [routesList, setRoutesList] = useState([]);
  const [routeNo, setRouteNo] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [selDriverName, setSelDriverName] = useState("");
  const [selDriverCode, setSelDriverCode] = useState("");
  const [driverList, setDriverList] = useState([]);
  const [selMileageType, setSelMileageType] = useState("");
  const [mileageTypeList, setMileageTypeList] = useState([]);
  const [currency, setCurrency] = useState("");
  const [exchRate, setExchRate] = useState("");
  const [selPaymentMode, setSelPaymentMode] = useState("");
  const [mileageAmountReq, setMileageAmountReq] = useState("");
  const [reqAmount, setReqAmount] = useState("");
  const [headerData, setHeaderData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [truckNo, setTruckNo] = useState("");
  const [make, setMake] = useState("");
  const [trucksList, setTrucksList] = useState([]);
  const [narration, setNarration] = useState("");
  const [selectedDataForApproval, setSelectedDataForApproval] = useState([]);
  const [hist, setHist] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [routeDistance, setRouteDistance] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [refNo, setRefNo] = useState("");
  const [standardOrVariable, setStandardOrVariable] = useState("");
  const [company, setCompany] = useState({});
  const [isDocPrinted, setIsDocPrinted] = useState(false);
  const [printCount,setPrintCount] = useState("")
  const [PopUpReport, setPopUpReport] = useState(false);
  const [LoadingScreenBlock, setLoadingScreenBlock] = useState(false);
  const [pdfData, setPdfData] = useState(null);
  const [isCancelled, setIsCancelled] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [reasonToCancel, setReasonToCancel] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString());
  const [endDate, setEndDate] = useState(new Date().toISOString());

    const [PopUpReportMM, setPopUpReportMM] = useState(false);
    const [LoadingScreenBlockMM, setLoadingScreenBlockMM] = useState(false);
    const [pdfDataMM, setPdfDataMM] = useState(null);

  // Filter Contracts
  const filteredContracts = contractsList.filter((item) => {
    const searchData = searchContract.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["CLIENTMAME", "CONTRACTNO", "CARGO"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Filter Routes
  const filteredRoutes = routesList.filter((item) => {
    const searchData = searchRoute.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["ENDLOC", "STARTLOC", "ROUTEID", "DISTANCE"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Filter Request
  const filteredRequest = headerData.filter((item) => {
    const searchData = searchRequest.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_REQUEST_DATE);
    const eDate = new Date(item.OT_REQUEST_DATE);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (searchData.length === 0 && !startDate && !endDate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "OT_REQUEST_NO",
        "OT_REQUEST_ROUTE_NO",
        "OT_REQUEST_MILEAGE_TYPE",
        "OT_REQUEST_INVOICE_NUMBER",
        "OT_REQUEST_MILEAGE_TRUCK_NO",
        "DRIVERNAME",
        "OT_REQUEST_MILEAGE_AMOUNT",
        "SALESINVOICENO",
        "OT_REQUEST_NARRATION",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const dateMatch = (!start || sDate >= start) && (!end || eDate <= end);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((res) => {
        setCompany(res?.data[0]);
      })
      .catch((err) => {
        console.log("Error While fetching Company Details", err);
      });

    // New Request Id
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1117`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRequestNo(response?.data[0]?.NEWID);
        setLatestRequestNo(response?.data[0]?.NEWID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Request No:", error);
      });

    // Contract List
    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1118`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     setContractsList(response?.data);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Contract Details:", error);
    //   });

    // ROUTES LIST
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=524`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRoutesList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Route Details:", error);
      });

    // Drivers List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriverList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver Details:", error);
      });

    // Vehicles List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setTrucksList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Vehicles Details:", error);
      });

    // View Expense
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1119`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setMileageTypeList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Mileage Type Details:", error);
      });

    //  Header Data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1116`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = [...(response?.data || [])].sort(
          (a, b) => Number(b.OT_REQUEST_NO) - Number(a.OT_REQUEST_NO),
        );
        setHeaderData(sortedData);
        setFirstRequestNo(response?.data[0]?.OT_REQUEST_NO);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Header Details:", error);
      });
  };

  // function getRoutesBasedOnContract(contract) {
  //   axios
  //     .get(
  //       `${BASEURL_GLOBAL}/globalViewHandler?viewname=653&CONTRACTNO=${contract}`,
  //       {
  //         headers: {
  //           "auth-token": authToken,
  //           "session-token": sessionToken,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setRoutesList(response?.data);
  //       setisloading(false);
  //     })
  //     .catch((error) => {
  //       setisloading(false);
  //       console.error("Error fetching Routes Details:", error);
  //     });
  // }

  function getCurrAndExchRate(expense, route, makeValue) {
    setCurrency("");
    setMileageAmountReq("0");
    setExchRate("0");
    setReqAmount("");
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1120&OM_MILEAGE_CATEGORY=${encodeURIComponent(expense)}&OM_MILEAGE_ROUTE=${encodeURIComponent(route)}&OM_MILEAGE_VEHICLE_MAKE=${encodeURIComponent(makeValue)}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        setCurrency(response?.data[0]?.OM_MILEAGE_CURRENCY);
        setMileageAmountReq(response?.data[0]?.OM_MILEAGE_AMOUNT);
        getExchRate(response?.data[0]?.OM_MILEAGE_CURRENCY);
        setReqAmount(response?.data[0]?.OM_MILEAGE_AMOUNT || "");
        setStandardOrVariable(response?.data[0]?.OM_MILEAGE_STANDARD_VARIABLE);
        setSelPaymentMode(response?.data[0]?.OM_MILEAGE_PAY_MODE);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error(
          "Error fetching Currency and Exchange Rate Details:",
          error,
        );
      });
  }

  function getExchRate(currency) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=604&CURRCODE=${currency}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      )
      .then((response) => {
        setExchRate(response?.data[0]?.EXCHRATE);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error(
          "Error fetching Currency and Exchange Rate Details:",
          error,
        );
      });
  }

  // * Adding To Grid
  const AddItemsToGrid = () => {
    if (!invoiceNo) {
      alert("Kindly supply Invoice No");
      return;
    }
    const isInvoiceExisting = headerData?.find(
      (item) =>
        item?.OT_REQUEST_MILEAGE_TYPE === selMileageType &&
        item?.OT_REQUEST_DRIVER_CODE === selDriverCode &&
        item?.OT_REQUEST_MILEAGE_TRUCK_NO === truckNo &&
        item?.SALESINVOICENO === invoiceNo,
    );

    if (isInvoiceExisting) {
      alert(
        "This Invoice No is already attached with the Selected Mileage Type, Driver and Vehicle",
      );
      return;
    }

    if (!selDriverCode) {
      alert("Please select Driver");
    } else if (!truckNo) {
      alert("Kindly Provide the Truck No");
    } else if (!selMileageType) {
      alert("Kindly Provide Mileage Type");
    } else if (!selPaymentMode) {
      alert("Kindly Provide Payment Mode");
    } else if (!reqAmount) {
      alert("Kindly Provide Request Amount");
    } else if (
      standardOrVariable === "STANDARD" &&
      Number(reqAmount) > Number(mileageAmountReq)
    ) {
      alert("Request Amount must not be greater than Mileage amount");
    } else {
      const newItem = {
        OT_REQUEST_DRIVER_CODE: selDriverCode,
        DRIVERNAME: selDriverName,
        OT_REQUEST_MILEAGE_TYPE: selMileageType,
        OT_REQUEST_MILEAGE_PAY_CODE: selPaymentMode,
        OT_REQUEST_MILEAGE_AMOUNT: reqAmount,
        OT_MILEAGE_AMOUNT: mileageAmountReq,
        OT_REQUEST_MILEAGE_CURRENCY: currency,
        OT_REQUEST_EXCHANGE_RATE: exchRate,
        OT_REQUEST_MILEAGE_TRUCK_NO: truckNo,
        SALESINVOICENO: invoiceNo,
      };
      const existingRowIndex = tableData.findIndex(
        (charge) =>
          charge.OT_REQUEST_MILEAGE_TRUCK_NO ===
            newItem.OT_REQUEST_MILEAGE_TRUCK_NO &&
          charge.OT_REQUEST_DRIVER_CODE === newItem.OT_REQUEST_DRIVER_CODE &&
          charge.OT_REQUEST_MILEAGE_TYPE === newItem.OT_REQUEST_MILEAGE_TYPE,
      );

      if (existingRowIndex !== -1) {
        const updatedItems = [...tableData];
        updatedItems[existingRowIndex] = newItem;
        setTableData(updatedItems);
      } else {
        setTableData([...tableData, newItem]);
      }

      setShowTable(true);
      clearallinputs();
    }
  };

  const clearallinputs = () => {
    setSelectedRowIndex(null);
    setSelDriverCode("");
    setSelDriverName("");
    setTruckNo("");
    setSelMileageType("");
    setSelPaymentMode("");
    setReqAmount("");
    setMileageAmountReq("");
    setCurrency("");
    setExchRate("");
    setMake("");
  };

  const RemoveItems = () => {
    const updatedValues = [...tableData];
    if (updatedValues.length === 0) {
      alert("There is no Tasks to be removed");
      setShowTable(false);
    } else {
      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setSelectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      setTableData(updatedValues);
      clearallinputs();
      if (updatedValues.length === 0) {
        setShowTable(false);
      }
    }
  };

  async function getNewRequestNo() {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1117`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setRequestNo(response?.data[0]?.NEWID);
        setLatestRequestNo(response?.data[0]?.NEWID);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching New Request No:", error);
      });
  }

  // Saving
  async function Save() {
    // await axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1116`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then(async (response) => {
    //     const sortedData = [...(response?.data || [])].sort(
    //       (a, b) => Number(b.OT_REQUEST_NO) - Number(a.OT_REQUEST_NO),
    //     );
    //     const isRequestAvailable = sortedData?.find(
    //       (item) => item?.OT_REQUEST_NO === Number(requestNo),
    //     );
    //     if (
    //       isRequestAvailable &&
    //       sortedData[0]?.OT_REQUEST_NO > latestRequestNo
    //     ) {
    //       await getNewRequestNo();
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching Header Details:", error);
    //   });

    if (duplicate === true) {
      for (let index = 0; index < tableData.length; index++) {
        const value = tableData[index];
        const isInvoiceExisting = headerData?.find(
          (item) =>
            item?.OT_REQUEST_MILEAGE_TYPE === value?.OT_REQUEST_MILEAGE_TYPE &&
            item?.OT_REQUEST_DRIVER_CODE === value?.OT_REQUEST_DRIVER_CODE &&
            item?.OT_REQUEST_MILEAGE_TRUCK_NO ===
              value?.OT_REQUEST_MILEAGE_TRUCK_NO &&
            item?.SALESINVOICENO === value?.SALESINVOICENO,
        );
        if (isInvoiceExisting) {
          alert(
            `This Invoice No: ${value?.SALESINVOICENO} is already attached with the Mileage Type: ${value?.OT_REQUEST_MILEAGE_TYPE} and Vehicle: ${value?.OT_REQUEST_MILEAGE_TRUCK_NO}`,
          );
          return;
        }
      }
    }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1114`,
        {
          OT_REQUEST_NO: Number(requestNo),
          OT_REQUEST_DATE: moment(date).format("YYYY/MM/DD"),
          OT_REQUEST_CONTRACT_NO: 0,
          OT_REQUEST_ROUTE_NO: routeNo ? Number(routeNo) : "",
          OT_REQUEST_PROCESSED_BY: user ? user : "",
          OT_REQUEST_PROCESSED_DATE: moment(date).format("YYYY/MM/DD")
            ? moment(date).format("YYYY/MM/DD")
            : "",
          OT_REQUEST_NARRATION: narration ? narration : "",
          OT_REQUEST_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
          OT_REQUEST_INVOICE_NUMBER: refNo ? refNo : 0,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        console.log(response);
        console.log(`Request Header Saved successfully`);
        await SaveDetails(response?.data?.message);
      } else {
        alert(`Error while saving Request Header`);
        setisloading(false);
        console.error(`Error while saving Request Header`);
      }
    } catch (error) {
      alert(`Error while saving Request Header`, error);
      setisloading(false);
      console.error(`Error while saving Request Header`, error);
    }
  }

  async function SaveDetails(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < tableData.length; index++) {
      const value = tableData[index];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1115`,
          {
            REQNO: docNo ? Number(docNo) : Number(requestNo),
            DRIVERCODE: value?.OT_REQUEST_DRIVER_CODE
              ? value?.OT_REQUEST_DRIVER_CODE
              : "",
            MILEAGETYPE: value.OT_REQUEST_MILEAGE_TYPE
              ? value?.OT_REQUEST_MILEAGE_TYPE
              : "",
            PAYCODE: value?.OT_REQUEST_MILEAGE_PAY_CODE
              ? value?.OT_REQUEST_MILEAGE_PAY_CODE
              : "",
            AMOUNT: value?.OT_REQUEST_MILEAGE_AMOUNT
              ? Number(value?.OT_REQUEST_MILEAGE_AMOUNT)
              : 0,
            CURRENCY: value?.OT_REQUEST_MILEAGE_CURRENCY
              ? value?.OT_REQUEST_MILEAGE_CURRENCY
              : "",
            EXCHANGERATE: value?.OT_REQUEST_EXCHANGE_RATE
              ? Number(value?.OT_REQUEST_EXCHANGE_RATE)
              : 0,
            TRUCKNO: value?.OT_REQUEST_MILEAGE_TRUCK_NO
              ? value?.OT_REQUEST_MILEAGE_TRUCK_NO
              : "",
            SALESINVOICENO: value?.SALESINVOICENO ? value?.SALESINVOICENO : "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Saving Details`, error);
        alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == tableData.length && successMessage) {
      //   alert(successMessage);
      alert(`Request Saved successfully`);
      const toPrint = window.confirm("Do you want to print?");
      if (toPrint) {
        setPopUpReport(true);
        generateReport(requestNo);
      } else {
        window.location.reload();
      }
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  async function getMileageVoucherNo() {
    try {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=400`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );
      if (response.status === 201) {
        return response?.data[0]?.MILEAGEVOUCHERNO;
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(`Error while generating Mileage Voucher Number`, error);
      alert("Failed to generate Mileage Voucher Number");
    }
  }

  async function ApproveSelected() {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    try {
      for (let index = 0; index < selectedDataForApproval.length; index++) {
        const value = selectedDataForApproval[index];
        const driver = driverList?.find(
          (item) => item?.DRIVERCODE === value?.OT_REQUEST_DRIVER_CODE,
        );

        let mileageVoucherNo = value?.MILEAGEVOUCHERNO;

        if (!mileageVoucherNo) {
          mileageVoucherNo = await getMileageVoucherNo();
        }

        if (!mileageVoucherNo) {
          alert(
            `Failed to generate Mileage Voucher Number for request no: ${value?.OT_REQUEST_NO}. Approval stopped.`,
          );
          setisloading(false);
          return; // ⛔ stop the entire function
        }

        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1226`,
          {
            MILEAGEVOUCHERNO: Number(mileageVoucherNo),
            DOCNO: value?.OT_REQUEST_NO ? Number(value?.OT_REQUEST_NO) : 0,
            MILEAGETYPE: value?.OT_REQUEST_MILEAGE_TYPE
              ? value?.OT_REQUEST_MILEAGE_TYPE
              : "",
            DRIVERCODE: value?.OT_REQUEST_DRIVER_CODE
              ? value?.OT_REQUEST_DRIVER_CODE
              : "",
            APPROVEDBY: user ? user : "",
            CONTRACTNO: value?.OT_REQUEST_CONTRACT_NO
              ? Number(value?.OT_REQUEST_CONTRACT_NO)
              : 0,
            ISSUEDATE: value?.OT_REQUEST_DATE
              ? moment(value?.OT_REQUEST_DATE).format("YYYY/MM/DD")
              : "",
            DRIVERNAME: driver?.DRIVERNAME ? driver?.DRIVERNAME : "",
            MILEAGEAMOUNT: value?.OT_REQUEST_MILEAGE_AMOUNT
              ? Number(value?.OT_REQUEST_MILEAGE_AMOUNT)
              : 0,
            NARRATION: value?.OT_REQUEST_NARRATION
              ? value?.OT_REQUEST_NARRATION
              : "",
            CURRENCY: value?.OT_REQUEST_MILEAGE_CURRENCY
              ? value?.OT_REQUEST_MILEAGE_CURRENCY
              : "",
            EXCHRATE: value?.OT_REQUEST_EXCHANGE_RATE
              ? Number(value?.OT_REQUEST_EXCHANGE_RATE)
              : 0,
            PAYMODE: value?.OT_REQUEST_MILEAGE_PAY_CODE
              ? value?.OT_REQUEST_MILEAGE_PAY_CODE
              : "",
            ROUTEID: value?.OT_REQUEST_ROUTE_NO
              ? Number(value?.OT_REQUEST_ROUTE_NO)
              : 0,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      }
      if (successCount == selectedDataForApproval.length && successMessage) {
        //   alert(successMessage);
        alert("Approved Successfully");
        setSelectedDataForApproval([]);
        window.location.reload();
      }
      if (errorMessage) {
        alert(errorMessage);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while Approving `, error);
      alert(error.response.data.message);
    } finally {
      setisloading(false);
    }
  }

  async function CancelSelected() {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    try {
      for (let index = 0; index < selectedDataForApproval.length; index++) {
        const value = selectedDataForApproval[index];
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1407`,
          {
            MILEAGEVOUCHERNO: Number(value?.MILEAGEVOUCHERNO),
            DOCNO: value?.OT_REQUEST_NO ? Number(value?.OT_REQUEST_NO) : 0,
            MILEAGETYPE: value?.OT_REQUEST_MILEAGE_TYPE
              ? value?.OT_REQUEST_MILEAGE_TYPE
              : "",
            DRIVERCODE: value?.OT_REQUEST_DRIVER_CODE
              ? value?.OT_REQUEST_DRIVER_CODE
              : "",
            CANCELLEDBY: user ? user : "",
            CANCELREASON: reasonToCancel ? reasonToCancel : "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      }
      if (successCount == selectedDataForApproval.length && successMessage) {
        alert("Cancelled Successfully");
        setSelectedDataForApproval([]);
        window.location.reload();
      }
      if (errorMessage) {
        alert(errorMessage);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while Cancelling `, error);
      alert(error.response.data.message);
    } finally {
      setisloading(false);
    }
  }

  const handleCheckboxChange = (row) => {
    setSelectedDataForApproval((prevSelected) => {
      const exists = prevSelected.some(
        (selectedRow) =>
          selectedRow.OT_REQUEST_MILEAGE_TRUCK_NO ===
            row.OT_REQUEST_MILEAGE_TRUCK_NO &&
          selectedRow?.OT_REQUEST_MILEAGE_TYPE === row?.OT_REQUEST_MILEAGE_TYPE,
      );
      if (exists) {
        // remove if already selected
        return prevSelected.filter(
          (selectedRow) =>
            !(
              selectedRow.OT_REQUEST_MILEAGE_TRUCK_NO ===
                row.OT_REQUEST_MILEAGE_TRUCK_NO &&
              selectedRow?.OT_REQUEST_MILEAGE_TYPE ===
                row?.OT_REQUEST_MILEAGE_TYPE
            ),
        );
      } else {
        // add new row
        return [...prevSelected, row];
      }
    });
  };

  const isRowChecked = (row) => {
    if (row?.MILEAGEAPPROVED === true) return true;
    if (
      !row ||
      !row?.OT_REQUEST_MILEAGE_TRUCK_NO ||
      !row?.OT_REQUEST_MILEAGE_TYPE
    )
      return false;
    return selectedDataForApproval.some(
      (r) =>
        r?.OT_REQUEST_MILEAGE_TRUCK_NO === row?.OT_REQUEST_MILEAGE_TRUCK_NO &&
        r?.OT_REQUEST_MILEAGE_TYPE === row?.OT_REQUEST_MILEAGE_TYPE,
    );
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      // Select all rows currently visible in filterData
      setSelectedDataForApproval(tableData);
    } else {
      // Unselect all
      setSelectedDataForApproval([]);
    }
  };

  // PRINT BIT FLAG
  async function PrintUpdate() {
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1404`,
        {
          DOCNO: Number(requestNo),
          PROCESSEDBY: user ? user : "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Request Header Saved successfully`);
        await getPrintCount();
      } else {
        alert(`Error while Logging Print`);
        console.error(`Error while Logging Print`);
      }
    } catch (error) {
      alert(`Error while saving Logging Print`, error);
      console.error(`Error while Logging Print`, error);
    }
  }

  async function getPrintCount() {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1116&OT_REQUEST_NO=${requestNo}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setPrintCount(response?.data[response?.data?.length - 1]?.PRINTCOUNT);
        if (response?.data[response?.data?.length - 1]?.PRINTCOUNT > 1) {
          alert(`This Request No ${requestNo} has taken print for ${response?.data[response?.data?.length - 1]?.PRINTCOUNT} times`)
        }
      })
      .catch((error) => {
        console.error("Error fetching Header Details:", error);
      });
  }

  function generateReport(DNOTEno) {
    setPdfData(null);

    setLoadingScreenBlock(true);

    axios
      .post(
        `${BASEURL}/generateReports`,
        {
          REPORTNAME: "CrMileageRequest.rpt",
          DOCNO: DNOTEno,
          // REPORTPATH: `C:\\AUTOEMAILS\\SGC`.replace(/\\\\/g, "\\"), // Converts \\ to \ for the request
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
          responseType: "blob",
        },
      )
      .then(async (res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfData(fileURL);
        setLoadingScreenBlock(false);
        await PrintUpdate();
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlock(false);
      });
  }

  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = pdfData;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  // Generate Report Date 
   function generateReportMM() {
    setPdfDataMM(null);
    const endDataFormat =
      endDate.slice(8, 10) +
      "/" +
      endDate.slice(5, 7) +
      "/" +
       endDate.slice(0, 4);
         const startDataFormat =
      startDate.slice(8, 10) +
      "/" +
      startDate.slice(5, 7) +
      "/" +
      startDate.slice(0, 4);
    console.log(endDataFormat);
    setLoadingScreenBlockMM(true);

    axios
      .post(
        `${BASEURL}/generatereport`,
        {
          REPORTNAME: "CrMonthtoDateMileageDetailedReport.rpt",
          STARTDATE: startDataFormat,
          ENDDATE: endDataFormat,
          DIVISIONBASED: "NO",
          DIVISIONNAME: "",
          SINGLEMULTIDATE: "Date Range",
          REPORTPATH: company?.REPORTPATH,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
          responseType: "blob", // Important for handling binary data
          timeout: 60000, // Set timeout to 60 seconds (60000 milliseconds)
        },
      )
      .then((res) => {
        console.log(res);
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        setPdfDataMM(fileURL);
        setLoadingScreenBlockMM(false);
      })
      .catch((err) => {
        console.log("Error generating report:", err);
        setLoadingScreenBlockMM(false);
      });
  }

  const handleDownloadMM = () => {
    const a = document.createElement("a");
    a.href = pdfDataMM;
    a.download = "generated_report.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleButtonClick = (action) => {
    let requestNoToPass;
    switch (action) {
      case "first":
        requestNoToPass = Number(firstRequestNo);
        break;
      case "decrement":
        requestNoToPass = Number(requestNo) - 1;
        if (requestNoToPass < Number(firstRequestNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        requestNoToPass = Number(requestNo) + 1;
        if (requestNoToPass >= Number(latestRequestNo)) {
          alert("No Further PO number");
          return;
        }
        break;

      case "latest":
        requestNoToPass = Number(latestRequestNo) - 1;
        break;
      default:
        break;
    }

    getNavData(requestNoToPass);
  };

  async function getNavData(request) {
    const item = headerData?.find((value) => value?.OT_REQUEST_NO === request);

    if (item) {
      setRequestNo(item?.OT_REQUEST_NO);
      setDate(item?.OT_REQUEST_DATE);
      setNarration(item?.OT_REQUEST_NARRATION);
      setRefNo(item?.OT_REQUEST_INVOICE_NUMBER);
      setRouteNo(item?.OT_REQUEST_ROUTE_NO);
      setIsDocPrinted(item?.OT_REQUEST_PRINTED == true ? true : false);
      const route = routesList?.find(
        (items) => items.ROUTEID == item?.OT_REQUEST_ROUTE_NO,
      );
      console.log(route);
      setFrom(route?.STARTLOC);
      setTo(route?.ENDLOC);
      setRouteDistance(route?.DISTANCE);
      setCreatedBy(item?.OT_REQUEST_PROCESSED_BY);
      setCreatedDate(item?.OT_REQUEST_PROCESSED_DATE);
      setShowRequest(false);
      const filtered = headerData?.filter(
        (items) =>
          items.OT_REQUEST_NO === item?.OT_REQUEST_NO &&
          items.OT_REQUEST_CONTRACT_NO === item?.OT_REQUEST_CONTRACT_NO,
      );

      setTableData(filtered);
      setHist(true);
      setShowTable(true);
    } else {
      // Auto-decrement if record not found
      const allVouchers = [...(headerData || [])]
        .map((item) => Number(item?.OT_REQUEST_NO))
        .sort((a, b) => a - b);

      const currentDispatch = Number(request);

      // Determine whether this was likely an increment or decrement action
      const lastDispatchNo = Number(requestNo);

      const isIncrement = currentDispatch > lastDispatchNo;

      if (isIncrement) {
        // Find next existing record greater than the current one
        const nextExisting = allVouchers.find((num) => num > currentDispatch);
        if (nextExisting !== undefined) {
          console.warn(
            `request No ${request} not found, trying ${nextExisting}`,
          );
          await getNavData(nextExisting);
          return;
        } else {
          alert(`No further request No found after ${request}`);
        }
      } else {
        const previousExisting = [...allVouchers]
          .reverse()
          .find((num) => num < Number(request));

        if (previousExisting !== undefined) {
          console.warn(
            `request No ${request} not found, trying ${previousExisting}`,
          );
          await getNavData(previousExisting);
          return;
        } else {
          alert(`No existing request No found before ${request}`);
        }
      }
    }
  }

  // ********** EXPORT TO PDF AND EXCEL **************

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Batch Mileage Issue Request");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 15, 15, 15, 25, 25, 25, 25, 25, 15, 15, 15, 35];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "REQUEST NO",
      "REQUEST DATE",
      "REF NO",
      "ROUTE ID",
      "FROM",
      "TO",
      "VEHICLE",
      "DRIVER",
      "MILEAGE TYPE",
      "AMOUNT",
      "CANCELLED",
      "INVOICE NO",
      "NARRATION",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Batch_Mileage_Issue_Request.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Batch Mileage Issue Request - Report", 10, 10);

    const columns = [
      "REQUEST NO",
      "REQUEST DATE",
      "REF NO",
      "ROUTE ID",
      "FROM",
      "TO",
      "VEHICLE",
      "DRIVER",
      "MILEAGE TYPE",
      "AMOUNT",
      "CANCELLED",
      "INVOICE NO",
      "NARRATION",
    ];

    const data = filteredRequest.map((stock) => {
      const route = routesList?.find(
        (item) => item.ROUTEID == stock.OT_REQUEST_ROUTE_NO,
      );
      return [
        stock.OT_REQUEST_NO,
        stock.OT_REQUEST_DATE
          ? moment(stock.OT_REQUEST_DATE).format("DD/MM/YYYY")
          : "",
        stock.OT_REQUEST_INVOICE_NUMBER,
        stock.OT_REQUEST_ROUTE_NO,
        route?.STARTLOC,
        route?.ENDLOC,
        stock.OT_REQUEST_MILEAGE_TRUCK_NO,
        stock.DRIVERNAME,
        stock.OT_REQUEST_MILEAGE_TYPE,
        stock.OT_REQUEST_MILEAGE_AMOUNT,
        stock.MILEAGECANCELLED === true ? "YES" : "NO",
        stock.SALESINVOICENO,
        stock.OT_REQUEST_NARRATION,
      ];
    });

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Batch_Mileage_Issue_Request.pdf");
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Batch Mileage Issue Request
        </h1>
      </div>

      <div className="flex lg:justify-end lg:mr-12 lg:ml-0 ml-2">
        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            window.location.reload();
          }}
        >
          New
        </button>
        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            if (hist === true) {
              getNewRequestNo();
              setHist(false);
              setDuplicate(true);
            } else {
              alert("Kindly save this Request No");
            }
          }}
        >
          Duplicate and New
        </button>
        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={async () => {
            const isInvoicePresent = headerData?.find(
              (item) => item?.OT_REQUEST_INVOICE_NUMBER == refNo,
            );
            if (isInvoicePresent?.OT_REQUEST_NO === Number(requestNo)) {
              await Save();
            } else {
              if (isInvoicePresent) {
                alert("This Ref No is attached to other Request No");
                return;
              } else {
                await Save();
              }
            }
          }}
        >
          Save
        </button>
        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={async () => {
            if (hist === true) {
              // if (isDocPrinted === false) {
              setPopUpReport(true);
              generateReport(requestNo);
              // } else {
              //   alert("The Print for this Request No is taken")
              // }
            } else {
              alert("Kindly Save the selected Request");
            }
          }}
        >
          Print
        </button>

        {PopUpReport && (
          <div>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 99,
              }}
            />

            {/* Popup */}
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "white",
                border: "1px solid black",
                height: "80%",
                width: "90%",
                maxWidth: "90%",
                maxHeight: "600px",
                padding: "16px",
                zIndex: 100,
                overflowY: "auto",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              {LoadingScreenBlock && <LoadingScreen />}
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setPopUpReport(false)}
              >
                Close
              </button>
              <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                <div>
                  <section className="lg:hidden block">
                    {pdfData && (
                      <button
                        className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                        onClick={handleDownload}
                      >
                        Download PDF
                      </button>
                    )}
                  </section>

                  <section className="lg:block">
                    {pdfData && pdfData !== "" ? (
                      <div className="mt-4">
                        <h2 className="text-lg font-bold">Generated Report</h2>
                        <object
                          key={pdfData}
                          data={pdfData}
                          type="application/pdf"
                          width="100%"
                          height="600px"
                        ></object>
                      </div>
                    ) : (
                      <p className="text-2xl font-bold my-4 text-center">
                        {LoadingScreenBlock
                          ? "Loading..."
                          : "No report available."}
                      </p>
                    )}
                  </section>
                </div>
              </section>
            </div>
          </div>
        )}
      </div>

      <div className="flex lg:mx-2 gap-1 mt-2 lg:ml-2 ml-2">
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("first");
          }}
        >
          {"<<"}
        </button>
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("decrement");
          }}
        >
          {"<"}
        </button>
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("increment");
          }}
        >
          {">"}
        </button>
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            handleButtonClick("latest");
          }}
        >
          {">>"}
        </button>
      </div>

      {/* Line 1 */}
      <div className="lg:flex lg:flex-row justify-between mt-2 lg:ml-0 ml-2">
        <div className="lg:flex">
          <p className="lg:ml-2 ">Request No :</p>
          <input
            className="w-20 text-right h-8 border border-black lg:ml-12 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={requestNo}
            readOnly
          ></input>
          <button
            className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {
              setShowRequest(true);
            }}
          >
            ...
          </button>
          <p className="lg:ml-2">Request Date :</p>
          <input
            className="w-32 h-8 border border-black lg:ml-2 rounded-md focus:outline-none focus:border-blue-500"
            type="date"
            value={date.split("T")[0]}
            onChange={(e) => setDate(e.target.value)}
          ></input>

          {hist === true && (
            <>
              <p className="lg:ml-2 font-bold text-red-500">Created By :</p>
              <p className="lg:ml-2">{createdBy}</p>
              <p className="lg:ml-2 font-bold text-red-500">Created Date :</p>
              <p className="lg:ml-2">
                {createdDate ? moment(createdDate).format("DD/MM/YYYY") : ""}
              </p>
            </>
          )}
        </div>

        {showRequest && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1200px] w-[95%] p-1 overflow-y-auto rounded-md">
            <div className="lg:flex lg:flex-row mt-2">
              <p className="text-red-600 lg:ml-2">Search :</p>
              <input
                className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="text"
                value={searchRequest}
                onChange={(e) => setSearchRequest(e.target.value)}
              ></input>

              <p className="text-red-600 lg:ml-2">Start Date:</p>
              <input
                className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="date"
                value={startDate?.split("T")[0]}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              ></input>
              <p className="text-red-600 lg:ml-2">End Date:</p>
              <input
                className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="date"
                value={endDate?.split("T")[0]}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
              ></input>
            </div>

            <div className="flex justify-end gap-2">
              <div className="cursor-pointer">
                <RiFileExcel2Line onClick={ExcelStockData} size={25} />
              </div>
              <div className="cursor-pointer">
                <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
              </div>
            </div>

            <div className="visible lg:h-[430px] p-1 z-0 lg:overflow-auto mt-2">
              <table className="w-full border border-gray-300 text-sm table_1">
                <thead className="sticky top-[-1px] table-header">
                  <tr className="bg-[#2b3f5c] text-white text-[12px]">
                    <td className="py-2 px-4 text-right border border-gray-300">
                      SNO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      REQUEST NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      REQUEST DATE
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      REF NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      ROUTE ID
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      FROM
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      TO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      VEHICLE
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      DRIVER
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      MILEAGE TYPE
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      AMOUNT
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      CANCELLED
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      INVOICE NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      NARRATION
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {filteredRequest?.map((value, index) => {
                    const route = routesList?.find(
                      (item) => item.ROUTEID == value.OT_REQUEST_ROUTE_NO,
                    );
                    return (
                      <tr
                        key={value?.OT_REQUEST_NO}
                        className="hover:bg-gray-100 cursor-pointer text-[13px]"
                        onClick={() => {
                          setRequestNo(value.OT_REQUEST_NO);
                          setDate(value.OT_REQUEST_DATE);
                          // setContractNo(value.OT_REQUEST_CONTRACT_NO);
                          setNarration(value.OT_REQUEST_NARRATION);
                          setRouteNo(value.OT_REQUEST_ROUTE_NO);
                          setIsDocPrinted(
                            value?.OT_REQUEST_PRINTED == true ? true : false,
                          );
                          // getRoutesBasedOnContract(value.OT_REQUEST_CONTRACT_NO);
                          const route = routesList?.find(
                            (item) => item.ROUTEID == value.OT_REQUEST_ROUTE_NO,
                          );
                          console.log(route);
                          setFrom(route?.STARTLOC);
                          setTo(route?.ENDLOC);
                          setRouteDistance(route?.DISTANCE);
                          setCreatedBy(value?.OT_REQUEST_PROCESSED_BY);
                          setCreatedDate(value?.OT_REQUEST_PROCESSED_DATE);
                          setShowRequest(false);
                          const filtered = headerData?.filter(
                            (item) =>
                              item.OT_REQUEST_NO === value.OT_REQUEST_NO &&
                              item.OT_REQUEST_CONTRACT_NO ===
                                value.OT_REQUEST_CONTRACT_NO,
                          );

                          setTableData(filtered);
                          setHist(true);
                          setShowTable(true);
                        }}
                      >
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_NO || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_DATE
                            ? moment(value.OT_REQUEST_DATE).format("DD/MM/YYYY")
                            : ""}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_INVOICE_NUMBER || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_ROUTE_NO || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {route?.STARTLOC || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {route?.ENDLOC || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_MILEAGE_TRUCK_NO || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.DRIVERNAME || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_MILEAGE_TYPE || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.OT_REQUEST_MILEAGE_AMOUNT || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.MILEAGECANCELLED === true ? "YES" : "NO"}
                        </td>
                        <td className="py-2 px-4 text-right border border-gray-300">
                          {value.SALESINVOICENO || "N/A"}
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          {value.OT_REQUEST_NARRATION || "N/A"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

             <button
              className="absolute top-2 right-20 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async() => {
                setPopUpReportMM(true);
                await generateReportMM();
              }}
            >
            Print Mileage Report
              
            </button>


              {PopUpReportMM && (
                        <div>
                          <div
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              zIndex: 99,
                            }}
                          />
            
                          {/* Popup */}
                          <div
                            style={{
                              position: "fixed",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              backgroundColor: "white",
                              border: "1px solid black",
                              height: "80%",
                              width: "90%",
                              maxWidth: "90%",
                              maxHeight: "600px",
                              padding: "16px",
                              zIndex: 100,
                              overflowY: "auto",
                              borderRadius: "8px",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            {LoadingScreenBlockMM && <LoadingScreen />}
                            <button
                              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2 focus:outline-none focus:ring focus:border-blue-300"
                              onClick={() => setPopUpReportMM(false)}
                            >
                              Close
                            </button>
                            <section className="lg:flex lg:flex-col bg-white p-4 gap-2 shadow-lg rounded-md w-full min-h-[500px]">
                              <div>
                                <section className="lg:hidden block">
                                  {pdfDataMM && (
                                    <button
                                      className="bg-blue-500 text-white rounded-md px-2 py-1 block my-1"
                                      onClick={handleDownloadMM}
                                    >
                                      Download PDF
                                    </button>
                                  )}
                                </section>
                                <section className="lg:block">
                                  {pdfDataMM ? (
                                    <div className="mt-4">
                                      <h2 className="text-lg font-bold">
                                        Generated Report
                                      </h2>
                                      <object
                                        key={pdfDataMM}
                                        data={pdfDataMM}
                                        title="Generated Report"
                                        width="100%"
                                        height="600px"
                                      />
                                    </div>
                                  ) : (
                                    <p className="text-2xl font-bold my-4 text-center">
                                      No report available.
                                    </p>
                                  )}
                                </section>
                              </div>
                            </section>
                          </div>
                        </div>
                      )}
            
            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowRequest(false)}
            >
              Close
            </button>
          </div>
        )}
      </div>

      {/* Line 2 */}
      <div className="lg:flex lg:flex-row mt-2 lg:ml-0 ml-2">
        {/* <p className="lg:ml-2">Contract Number :</p>
        <input
          className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={contractNo}
          readOnly
        ></input>

        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            setShowContract(true);
          }}
        >
          ...
        </button>

        {showContract && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
            <div className="lg:flex lg:flex-row mt-2">
              <p className="text-red-600 lg:ml-2">Search :</p>
              <input
                className="w-64  h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="text"
                value={searchContract}
                onChange={(e) => setSearchContract(e.target.value)}
              ></input>
            </div>

            <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
              <table className="w-full border border-gray-300 text-sm">
                <thead className="sticky top-0">
                  <tr className="bg-[#2b3f5c] text-white text-[12px]">
                    <td className="py-2 px-4 text-right border border-gray-300">
                      SNO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      CONTRACT NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      CLIENT NAME
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      CARGO
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {filteredContracts?.map((value, index) => (
                    <tr
                      key={value?.CONTRACTNO}
                      className="hover:bg-gray-100 cursor-pointer text-[13px]"
                      onClick={() => {
                        setContractNo(value.CONTRACTNO);
                        setShowContract(false);
                        getRoutesBasedOnContract(value.CONTRACTNO);
                      }}
                    >
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {index + 1}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.CONTRACTNO || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.CLIENTMAME || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.CARGO || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowContract(false)}
            >
              Close
            </button>
          </div>
        )} */}

        <p className="lg:ml-2 lg:mr-2">Route :</p>
        <input
          className="w-20 text-right h-8 border border-black lg:ml-20 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={routeNo}
          readOnly
        ></input>

        <button
          className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
          onClick={() => {
            // if (!contractNo) {
            //   alert("Kindly Supply Contract No");
            // } else {
            setShowRoute(true);
            // }
          }}
        >
          ...
        </button>

        {showRoute && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
            <div className="lg:flex lg:flex-row mt-2">
              <p className="text-red-600 lg:ml-2">Search :</p>
              <input
                className="w-64  h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="text"
                value={searchRoute}
                onChange={(e) => setSearchRoute(e.target.value)}
              ></input>
            </div>

            <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
              <table className="w-full border border-gray-300 text-sm">
                <thead className="sticky top-0">
                  <tr className="bg-[#2b3f5c] text-white text-[12px]">
                    <td className="py-2 px-4 text-right border border-gray-300">
                      SNO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      ROUTE NO
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      FROM LOCATION
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      TO LOCATION
                    </td>
                    <td className="py-2 px-4 text-left border border-gray-300">
                      DISTANCE
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {filteredRoutes.map((value, index) => (
                    <tr
                      key={value?.ROUTEID}
                      className="hover:bg-gray-100 cursor-pointer text-[13px]"
                      onClick={() => {
                        setRouteNo(value.ROUTEID);
                        setFrom(value.STARTLOC);
                        setTo(value.ENDLOC);
                        setRouteDistance(value?.DISTANCE);
                        if (selMileageType && make) {
                          getCurrAndExchRate(
                            selMileageType,
                            value?.ROUTEID,
                            make,
                          );
                        }
                        setShowRoute(false);
                      }}
                    >
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {index + 1}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.ROUTEID || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.STARTLOC || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.ENDLOC || "N/A"}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.DISTANCE || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button
              className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => setShowRoute(false)}
            >
              Close
            </button>
          </div>
        )}

        <p className="lg:ml-2">From :</p>
        <input
          className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={from}
          readOnly
        ></input>
        <p className="lg:ml-2">To :</p>
        <input
          className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={to}
          readOnly
        ></input>
        <p className="lg:ml-2">Distance :</p>
        <input
          className="w-28 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={routeDistance}
          readOnly
        ></input>
      </div>

      {/* Line 3 */}

      <div className="lg:flex lg:flex-row mt-2 lg:ml-0 ml-2">
        <p className="lg:ml-2">Narration :</p>
        <textarea
          rows={3}
          className="lg:w-[600px] resize-none border border-black lg:ml-16 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="text"
          value={narration}
          onChange={(e) => {
            if (routeNo) {
              setNarration(e.target.value);
            } else {
              alert("Kindly provide Route");
            }
          }}
        ></textarea>
        <p className="lg:ml-2">Ref No :</p>
        <input
          className="w-28 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
          type="number"
          value={refNo}
          onChange={(e) => setRefNo(e.target.value)}
        ></input>
      </div>

      <div className="border border-gray-400 p-4 w-[1280px] rounded-md relative mt-4">
        <p className="absolute -top-3 left-2 bg-white px-1 text-red-600 text-sm">
          Specify Mileages to be issued and Tick the Journeys
        </p>

        {/* Line 1 */}
        <div className="lg:flex lg:flex-row mt-2">
          <p className="lg:ml-2">Truck :</p>
          <Select
            className="lg:w-48 w-48 lg:ml-24"
            value={
              truckNo
                ? { value: truckNo, label: truckNo }
                : { value: "", label: "Select Truck" }
            }
            onChange={(e) => {
              if (!narration) {
                alert("Kindly Supply Narration");
              } else {
                setTruckNo(e.value);
                const truck = trucksList?.find(
                  (item) => item?.["VEHICLE REG NO"] === e.value,
                );
                setMake(truck?.MAKE);
                setSelDriverName(truck?.DRIVERNAME);
                setSelDriverCode(truck?.DRIVERCODE);
                if (selMileageType && routeNo) {
                  getCurrAndExchRate(selMileageType, routeNo, truck?.MAKE);
                }
              }
            }}
            options={[
              { value: "", label: "Select Truck" },
              ...trucksList?.map((item) => ({
                value: item["VEHICLE REG NO"],
                label: item["VEHICLE REG NO"],
              })),
            ]}
          ></Select>

          <p className="lg:ml-4">Make :</p>
          <input
            className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={make}
            readOnly
          ></input>

          <p className="lg:ml-5 ">Driver Name :</p>
          <Select
            className="lg:w-96 w-64 lg:ml-2"
            value={
              selDriverName
                ? { value: selDriverName, label: selDriverName }
                : { value: "", label: "Select Driver" }
            }
            onChange={(e) => {
              if (!narration) {
                alert("Kindly Supply Narration");
              } else {
                setSelDriverName(e.label);
                setSelDriverCode(e.value);
              }
            }}
            options={[
              { value: "", label: "Select Driver" },
              ...driverList?.map((item) => ({
                value: item.DRIVERCODE,
                label: item.DRIVERNAME,
              })),
            ]}
          ></Select>
        </div>

        {/* Line 2 */}
        <div className="lg:flex lg:flex-row mt-2">
          <p className="lg:ml-2 ">Mileage Type :</p>
          <Select
            className="lg:w-72 w-64 lg:ml-10"
            value={
              selMileageType
                ? { value: selMileageType, label: selMileageType }
                : { value: "", label: "Select Mileage Type" }
            }
            onChange={(e) => {
              if (!truckNo) {
                alert("Kindly provide Truck No");
              } else {
                if (e.value !== "") {
                  setSelMileageType(e.value);
                  if (routeNo && make)
                    getCurrAndExchRate(e.value, routeNo, make);
                } else {
                  setSelMileageType("");
                }
              }
            }}
            options={[
              { value: "", label: "Select Mileage Type" },
              ...mileageTypeList?.map((item) => ({
                value: item.OM_EXPENSE_CODE,
                label: item.OM_EXPENSE_CODE,
              })),
            ]}
          ></Select>

          <p className="lg:ml-4 ">Payment Mode :</p>
          <Select
            className="lg:w-64 w-64 lg:ml-2"
            value={
              selPaymentMode
                ? { value: selPaymentMode, label: selPaymentMode }
                : { value: "", label: "Select Payment Mode" }
            }
            onChange={(e) => {
              if (!selMileageType) {
                alert("Kindly Provide Mileage Type");
              } else {
                setSelPaymentMode(e.value);
              }
            }}
            options={[
              { value: "", label: "Select Payment Mode" },
              { value: "CASH", label: "CASH" },
              { value: "CREDIT", label: "CREDIT" },
              { value: "MPESA", label: "MPESA" },
            ]}
          ></Select>

          <p className=" lg:ml-4">Currency :</p>
          <input
            className="w-20 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={currency}
            readOnly
          ></input>

          <p className=" lg:ml-4">Exch Rate :</p>
          <input
            className="w-20 h-8 text-right border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="number"
            value={exchRate}
          ></input>
        </div>

        {/* Line 3 */}
        <div className="lg:flex lg:flex-row mt-2"></div>

        {/* Line 4 */}
        <div className="lg:flex lg:flex-row mt-2">
          <p className=" lg:ml-2">Mileage Amt(Req) :</p>
          <input
            className="w-24 h-8 text-right border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="number"
            value={mileageAmountReq}
            readOnly
            // onChange={(e) => setMileageAmountReq(e.target.value)}
          ></input>

          <p className=" lg:ml-2">Requested Amt:</p>
          <input
            className="w-24 h-8 text-right border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="number"
            value={reqAmount}
            onChange={(e) => setReqAmount(e.target.value)}
          ></input>

          <p className=" lg:ml-2">Invoice No :</p>
          <input
            className="w-[610px] h-8 text-right border border-black lg:ml-4 p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={invoiceNo}
            onChange={(e) => setInvoiceNo(e.target.value)}
          ></input>
        </div>

        <div className="flex lg:flex-row flex-col lg:justify-end gap-2 lg:mt-2 mt-2">
          <button
            className="w-40 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {
              AddItemsToGrid();
            }}
          >
            Add Requested
          </button>

          <button
            className="w-40 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {
              RemoveItems();
            }}
          >
            Remove Requested
          </button>

          <button
            className="w-40 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={async () => {
              if (selectedDataForApproval.length === 0) {
                alert("Kindly Select Rows from the table to approve");
                return;
              } else {
                await ApproveSelected();
              }
            }}
          >
            Approve Selected
          </button>

          <button
            className="w-40 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {
              if (selectedDataForApproval.length === 0) {
                alert("Kindly Select Rows from the table to Cancel");
                return;
              } else {
                setShowCancel(true);
              }
            }}
          >
            Cancel Selected
          </button>

          {showCancel && (
            <div className="absolute top-2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[250px] h-[80%] lg:w-[600px] w-[95%] p-1 overflow-y-auto rounded-md">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Reason To Cancel :</p>
                <textarea
                  className="w-80 resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  rows={5}
                  value={reasonToCancel}
                  onChange={(e) => setReasonToCancel(e.target.value)}
                ></textarea>
              </div>
              <div className="flex justify-center mt-2">
                <button
                  className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={async () => {
                    if (!reasonToCancel) {
                      alert("Kindly provide Reason to Cancel");
                      return;
                    } else {
                      await CancelSelected();
                    }
                  }}
                >
                  CANCEL
                </button>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowCancel(false)}
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Table */}
      {showTable && (
        <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
          {hist === true && (
            <div className="flex items-center gap-2 mt-2 lg:ml-12">
              <input
                className="lg:ml-2 w-5 h-5"
                type="checkbox"
                checked={
                  tableData?.length > 0 &&
                  selectedDataForApproval?.length === tableData?.length
                }
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              <p className="text-blue-800 font-medium text-sm">Select All</p>
            </div>
          )}
          <table className="table-auto border border-gray-300 text-sm">
            <thead className="sticky top-0">
              <tr className="bg-[#2b3f5c] text-white text-[12px]">
                <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                  SNO
                </td>
                {hist === true && (
                  <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                    SELECT
                  </td>
                )}
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  DRIVER NAME
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  TRUCK NO
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  MILEAGE TYPE
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  PAYMENT MODE
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  MILEAGE AMOUNT
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  CURRENCY
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  EXCHANGE RATE
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  INVOICE NO
                </td>
                <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                  CANCELLED ?
                </td>
              </tr>
            </thead>
            <tbody>
              {tableData.map((value, index) => {
                return (
                  <tr
                    key={index}
                    className="hover:bg-gray-100 cursor-pointer text-[13px]"
                    onClick={() => {
                      setSelDriverName(value?.DRIVERNAME);
                      setSelDriverCode(value?.OT_REQUEST_DRIVER_CODE);
                      setTruckNo(value?.OT_REQUEST_MILEAGE_TRUCK_NO);
                      setSelMileageType(value?.OT_REQUEST_MILEAGE_TYPE);
                      setSelPaymentMode(value?.OT_REQUEST_MILEAGE_PAY_CODE);
                      setReqAmount(value?.OT_REQUEST_MILEAGE_AMOUNT || "");
                      setMileageAmountReq(value?.OT_MILEAGE_AMOUNT);
                      setCurrency(value?.OT_REQUEST_MILEAGE_CURRENCY);
                      setExchRate(value?.OT_REQUEST_EXCHANGE_RATE);
                      setInvoiceNo(value?.SALESINVOICENO);
                      const truck = trucksList?.find(
                        (item) =>
                          item?.["VEHICLE REG NO"] ===
                          value?.OT_REQUEST_MILEAGE_TRUCK_NO,
                      );
                      setMake(truck?.MAKE);
                      setSelectedRowIndex(index);
                    }}
                  >
                    <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                      {index + 1}
                    </td>
                    {hist === true && (
                      <td
                        className="border px-4 py-2 text-center"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <input
                          type="checkbox"
                          className="w-5 h-5"
                          checked={isRowChecked(value)}
                          onChange={() => {
                            handleCheckboxChange(value);
                          }}
                        />
                      </td>
                    )}
                    <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                      {value.DRIVERNAME || "N/A"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                      {value.OT_REQUEST_MILEAGE_TRUCK_NO || "N/A"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                      {value.OT_REQUEST_MILEAGE_TYPE || "N/A"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                      {value.OT_REQUEST_MILEAGE_PAY_CODE || "N/A"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                      {value.OT_REQUEST_MILEAGE_AMOUNT || "0"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 text-left border border-gray-300">
                      {value.OT_REQUEST_MILEAGE_CURRENCY || "N/A"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                      {value.OT_REQUEST_EXCHANGE_RATE || "0"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 text-right border border-gray-300">
                      {value.SALESINVOICENO || "0"}
                    </td>
                    <td className="whitespace-nowrap py-2 px-4 border border-gray-300">
                      {value.MILEAGECANCELLED === null ? "NO" : "YES"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default MileageIssueRequest;
